module.exports = __webpack_public_path__ + "img/pocket-12_en.28b9af5.jpg";